/*Third Party Imports Starts*/
import {Form, Field, ErrorMessage} from 'vee-validate';
/*Third Party Imports Ends*/

import AuthLogo from "@/components/auth/logo/AuthLogo";
import AuthMain from "@/pages/auth/AuthMain";
import Button from '@/components/common/Button'
import DashboardMain from '@/pages/dashboard/DashboardMain.vue'
import DefaultLayout from "@/components/common/DefaultLayout";
import Footer from '@/components/layout/Footer'
import ForgetPassword from '@/pages/auth/ForgetPassword'
import Header from '@/components/layout/Header.vue'
import Login from '@/pages/auth/Login'
import Stats from '@/pages/dashboard/stats/Stats.vue'
import SendOtp from "@/pages/auth/otp/SendOtp";
import SetPasscode from "@/pages/auth/passcode/SetPasscode"
import SideBar from '@/components/layout/SideBar.vue'
import SignUp from '@/pages/auth/SignUp'
import VerifyOtp from "@/pages/auth/otp/VerifyOtp"
import PasscodeLogin from "@/pages/auth/passcode/PasscodeLogin";
import Withdrawal from "@/pages/dashboard/withdrawal/Withdrawal";
import AddWithdrawalMethod from '@/pages/dashboard/withdrawal/AddWithdrawalMethod'
import WithdrawalMethodModal from '@/pages/dashboard/withdrawal/WithdrawalMethodModal'
import AddWithdrawalRequest from "@/pages/dashboard/withdrawal/AddWithdrawalRequest";
import WithdrawalRequestDetailModal from "@/pages/dashboard/withdrawal/WithdrawalRequestDetailModal"
import OverlayLogo from "@/components/common/OverlayLogo";
import CommonPaginator from "@/components/common/CommonPaginator";
import Pagination from 'v-pagination-3';
import CommonTable from "@/components/common/CommonTable";
import VerifyEmailPhone from "@/pages/dashboard/send-money/VerifyEmailPhone";
import InitiateSendMoney from "@/pages/dashboard/send-money/InitiateSendMoney"
import ConfirmSendMoney from "@/pages/dashboard/send-money/ConfirmSendMoney"
import TransactionSuccessModal from "@/components/common/TransactionSuccessModal"
import GetMoneyRequests from "@/pages/dashboard/request-money/GetMoneyRequests"
import InitiateMoneyRequest from "@/pages/dashboard/request-money/InitiateMoneyRequest"
import DepositMoneyMain from "@/pages/dashboard/deposit-money/DepositMoneyMain"
import InitiateDepositMoney from "@/pages/dashboard/deposit-money/InitiateDepositMoney"
import RedirectingModal from "@/pages/dashboard/deposit-money/RedirectingModal"
import Transaction from "@/pages/dashboard/transaction/Transaction"
import TransactionDetailModal from "@/pages/dashboard/transaction/TransactionDetailModal"
import SelectOptions from "@/components/common/SelectOptions";
import Refund from "@/pages/dashboard/refund/Refund";
import CreateRefund from "@/pages/dashboard/refund/CreateRefund";
import PaymentLink from "@/pages/dashboard/payment-link/PaymentLink";
import AddPaymentLink from "@/pages/dashboard/payment-link/AddPaymentLink";
import Logout from "@/components/auth/logout/Logout";
import Breadcrumb from "@/components/common/Breadcrumb";
import InitiateUserRequestSendMoney from "@/pages/dashboard/request-money/send-money/InitiateUserRequestSendMoney";
import ConfirmUserRequestSendMoney from "@/pages/dashboard/request-money/send-money/ConfirmUserRequestSendMoney";
import Profile from "@/pages/dashboard/profile/Profile";
import ToastificationContent from "@/components/common/ToastificationContent";
import AppSetting from "@/pages/dashboard/app-settings/AppSetting";
import RevokeConfirmationModal from "@/pages/dashboard/app-settings/RevokeConfirmationModal";
import ConfirmationModal from "@/components/common/ConfirmationModal";
import Staff from '@/pages/dashboard/staff/Staff'
import StaffPermission from '@/pages/dashboard/staff/StaffPermission'
import AddStaff from '@/pages/dashboard/staff/AddStaff'
import UpdateStaff from '@/pages/dashboard/staff/UpdateStaff'
import TransactionDetailPage from "@/pages/dashboard/transaction/TransactionDetailPage";
import TransactionAttempt from "@/pages/dashboard/transaction/TransactionAttempt";
import PaymentLinkView from "@/pages/dashboard/payment-link/PaymentLinkView";
import AccountLedger from "@/pages/dashboard/account-ledger/AccountLedger"
import ApiPayment from "@/pages/dashboard/api-payment/ApiPayment"
import Customer from "@/pages/dashboard/customer/Customer"
import BalanceOnHold from '@/pages/dashboard/balance-onHold/BalanceOnHold'
import RefundModal from "@/pages/dashboard/refund/RefundModal";
import RefundDetailsModal from "@/pages/dashboard/refund/RefundDetailsModal";
import UserInputForm from "@/pages/auth/UserInputForm";
import SkeletonLoader from "@/components/common/SkeletonLoader.vue"
import TransactionReport from "@/pages/dashboard/reports/TransactionReport";
import VerifyEmailGeneral from "@/pages/auth/VerifyEmailGeneral"
import ResetPassword from "@/pages/auth/ResetPassword"
import ResetPin from "@/pages/auth/ResetPin"
import AllNotification from "@/pages/dashboard/Notifications/AllNotification"
import AggregateSettlement from "@/pages/dashboard/settlement/AggregateSettlement";
import DirectSettlement from '@/pages/dashboard/settlement/DirectSettlement'
import AggregateSettlementDetail from "@/pages/dashboard/settlement/AggregateSettlementDetail";
import DirectSettlementDetail from "@/pages/dashboard/settlement/DirectSettlementDetail";
import PaymentLinkAttempListing from "@/pages/dashboard/payment-link/PaymentLinkAttempListing";
import PaymentLinkAttempLogs from "@/pages/dashboard/payment-link/PaymentLinkAttempLogs";
import TransactionDetialPageWithId from "@/pages/dashboard/transaction/TransactionDetialPageWithId";
import VueApexCharts from "vue3-apexcharts";
import LoadMoreCommonTable from "@/components/common/LoadMoreCommonTable";
import DetailTextModal from "@/components/common/DetailTextModal";
// register components
export const registerComponents = (app) => {

    /*
    |--------------------------------------------------------------------------
    | Third Party Components Registration
    |--------------------------------------------------------------------------
    |
    | Register Your third party Components Here
    |
    */

    // vee validate component registration starts
    app.component('Form', Form)
    app.component('Field', Field)
    app.component('ErrorMessage', ErrorMessage)
    app.component('Breadcrumb', Breadcrumb)
    app.component('ToastificationContent', ToastificationContent)
    app.component('apexchart',VueApexCharts);
    // vee validate component registration ends

    /*
    |--------------------------------------------------------------------------
    | Layout Components Registration
    |--------------------------------------------------------------------------
    |
    | Register Your Main Layout Components Here
    |
    */

    app.component('Footer', Footer);
    app.component('Header', Header);
    app.component('SideBar', SideBar);

    /*
    |--------------------------------------------------------------------------
    | Common Components Registration
    |--------------------------------------------------------------------------
    |
    | Register Your Common Components Here
    |
    */

    app.component('DefaultLayout', DefaultLayout);
    app.component('Button', Button);
    app.component('OverlayLogo', OverlayLogo);
    app.component('ConfirmationModal', ConfirmationModal);
    app.component('DetailTextModal', DetailTextModal);

    /*
    |--------------------------------------------------------------------------
    | Pages Components Registration
    |--------------------------------------------------------------------------
    |
    | Register Your Pages Components Here
    |
    */

    /*
     * dashboard registration starts*/

    app.component('DashboardMain', DashboardMain);

    // stats registration starts
    app.component('Stats', Stats);
    // stats registration ends


    // payment-link registration starts
    app.component('PaymentLink', PaymentLink);
    app.component('AddPaymentLink', AddPaymentLink);
    app.component('PaymentLinkView', PaymentLinkView);
    app.component('PaymentLinkAttempListing', PaymentLinkAttempListing);
    app.component('PaymentLinkAttempLogs', PaymentLinkAttempLogs);
    // payment-link registration ends

    // refund registration starts
    app.component('Refund', Refund);
    app.component('CreateRefund', CreateRefund);
    app.component('RefundModal', RefundModal);
    app.component('RefundDetailsModal', RefundDetailsModal);
    // refund registration ends

    // send-money registration starts
    app.component('VerifyEmailPhone', VerifyEmailPhone);
    app.component('InitiateSendMoney', InitiateSendMoney);
    app.component('ConfirmSendMoney', ConfirmSendMoney);
    app.component('TransactionSuccessModal', TransactionSuccessModal);
    // send-money registration ends

    // request-money registration starts
    app.component('GetMoneyRequests', GetMoneyRequests);
    app.component('InitiateMoneyRequest', InitiateMoneyRequest);
    app.component('InitiateUserRequestSendMoney', InitiateUserRequestSendMoney);
    app.component('ConfirmUserRequestSendMoney', ConfirmUserRequestSendMoney);
    // request-money registration ends

    // deposit-money registration starts
    app.component('DepositMoneyMain', DepositMoneyMain);
    app.component('InitiateDepositMoney', InitiateDepositMoney);
    app.component('RedirectingModal', RedirectingModal);
    // deposit-money registration ends

    // transaction registration starts
    app.component('Transaction', Transaction);
    app.component('TransactionDetailModal', TransactionDetailModal);
    app.component('TransactionDetailPage', TransactionDetailPage);
    app.component('TransactionAttempt', TransactionAttempt);
    app.component('TransactionDetialPageWithId', TransactionDetialPageWithId);
    // transaction registration ends

    // withdrawal registration starts
    app.component('AddWithdrawalMethod', AddWithdrawalMethod);
    app.component('Withdrawal', Withdrawal);
    app.component('WithdrawalMethodModal', WithdrawalMethodModal);
    app.component('AddWithdrawalRequest', AddWithdrawalRequest);
    app.component('WithdrawalRequestDetailModal', WithdrawalRequestDetailModal);
    // withdrawal registration ends

    // profile registration starts
    app.component('Profile', Profile);
    // profile registration ends

    // app settings registration starts
    app.component('AppSetting', AppSetting);
    app.component('RevokeConfirmationModal', RevokeConfirmationModal);
    // app settings registration ends

    // staff registration starts
    app.component('Staff', Staff);
    app.component('StaffPermission', StaffPermission);
    app.component('AddStaff', AddStaff);
    app.component('UpdateStaff', UpdateStaff);
    // staff registration ends

    // Customer registration starts
    app.component('Customer', Customer);
    // Customer registration ends

    // AccountLedger registration starts
    app.component('AccountLedger', AccountLedger);
    // AccountLedger registration ends

    // ApiPayment registration starts
    app.component('ApiPayment', ApiPayment);
    // ApiPayment registration ends


    // BalanceOnHold registration starts
    app.component('BalanceOnHold', BalanceOnHold);
    // BalanceOnHold registration ends


    // TransactionReport registration starts
    app.component('TransactionReport', TransactionReport);
    // TransactionReport registration ends


    // AllNotification registration starts
    app.component('AllNotification', AllNotification);
    // AllNotification registration ends

    // DirectSettlement registration starts
    app.component('DirectSettlement', DirectSettlement);
    app.component('AggregateSettlement', AggregateSettlement);
    app.component('DirectSettlementDetail', DirectSettlementDetail);
    app.component('AggregateSettlementDetail', AggregateSettlementDetail);
    // DirectSettlement registration ends

    /*
     * dashboard registration ends*/

    /*
     * auth registration starts*/
    app.component('AuthLogo', AuthLogo);
    app.component('AuthMain', AuthMain);
    app.component('SendOtp', SendOtp);
    app.component('SetPasscode', SetPasscode);
    app.component('PasscodeLogin', PasscodeLogin);
    app.component('VerifyOtp', VerifyOtp);
    app.component('ForgetPassword', ForgetPassword);
    app.component('Login', Login);
    app.component('SignUp', SignUp);
    app.component('Logout', Logout);
    app.component('UserInputForm', UserInputForm);
    app.component('VerifyEmailGeneral', VerifyEmailGeneral);
    app.component('ResetPin', ResetPin);
    app.component('ResetPassword', ResetPassword);
    /*
     * auth registration ends*/


    /*
     * pagination components starts*/
    app.component('CommonPaginator', CommonPaginator);
    app.component('Pagination', Pagination);
    app.component('CommonTable', CommonTable);
    app.component('LoadMoreCommonTable', LoadMoreCommonTable);
    app.component('SelectOptions', SelectOptions);
    /*
     * pagination components ends*/

    /*
    Skeleton loader Starts
    */
    app.component('SkeletonLoader', SkeletonLoader);

    /*
     Skeleton loader Ends
     */


}
